import { render, staticRenderFns } from "./NumericAttribute.vue?vue&type=template&id=97291f66"
import script from "./NumericAttribute.vue?vue&type=script&lang=js"
export * from "./NumericAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports